import React from "react";
import { Button, ButtonProps, CircularProgress, styled } from "@mui/material";

// Primary Button
const StyledPrimaryButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#4F46E5",
  color: "#fff",
  fontSize: "16px",
  fontWeight: 500,
  fontFamily: "Inter, sans-serif",
  textAlign: "center",
  borderRadius: "8px",
  padding: "10px 16px",
  textTransform: "capitalize",
  // border: "1px solid #0C2340",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  height: "44px",

  "@media (max-width: 480px)": {
    width: "100%",
    padding: "8px 16px",
    fontSize: "14px",
    fontWeight: 500,
  },
  //   "&:hover": {
  //     backgroundColor: "#D12047",
  //   },
}));

interface PrimaryButtonProps extends ButtonProps {
  loading?: boolean;
}

export const PrimaryButton = ({ children, loading, disabled, ...props }: PrimaryButtonProps) => {
  return (
    <StyledPrimaryButton disabled={loading || disabled} {...props}>
      {loading ? (
        <>
          {children} <CircularProgress size={20} sx={{ color: "#fff", ml: 1 }} />
        </>
      ) : (
        children
      )}
    </StyledPrimaryButton>
  );
};




// light Button
export const LightButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#F3F4F6",
  color: "#374151",
  fontSize: "16px",
  fontWeight: 500,
  fontFamily: "Inter, sans-serif",
  textAlign: "center",
  borderRadius: "8px",
  padding: "10px 16px",
  textTransform: "capitalize",
  // border: "1px solid #0C2340",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  height: "44px",

  "@media (max-width: 480px)": {
    width: "100%",
    padding: "8px 16px",
    fontSize: "14px",
    fontWeight: 500,
  },
  //   "&:hover": {
  //     backgroundColor: "#D12047",
  //   },
}));

// light Button
export const TextButton = styled(Button)(({ theme }) => ({
  backgroundColor: "transparent",
  color: "#374151",
  fontSize: "16px",
  fontWeight: 500,
  fontFamily: "Inter, sans-serif",
  textAlign: "center",
  borderRadius: "8px",
  padding: "10px 16px",
  textTransform: "inherit",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  height: "44px",

  "@media (max-width: 480px)": {
    width: "100%",
    padding: "8px 16px",
    fontSize: "14px",
    fontWeight: 500,
  },
  "&:hover": {
    colors: "#4B5563"
  },
}));


// Primary Button
export const DangerButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#DF1C41",
  color: "#fff",
  fontSize: "16px",
  fontWeight: 500,
  fontFamily: "Inter, sans-serif",
  textAlign: "center",
  borderRadius: "8px",
  padding: "10px 16px",
  textTransform: "capitalize",
  // border: "1px solid #0C2340",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  height: "44px",

  "@media (max-width: 480px)": {
    width: "100%",
    padding: "8px 16px",
    fontSize: "14px",
    fontWeight: 500,
  },
  "&:hover": {
    backgroundColor: "#ff0030",
  },
}));